// src/pages/servicos/cadastros/TipoEquipamentoCad.js
import React, { useEffect, useState } from 'react';

import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useTipoEquipamento } from '../../../contexts/servicos/TipoEquipamentoContext';
import { TipoEquipamento } from '../../../models/servicos/TipoEquipamento';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const TipoEquipamentoCad = ({ show, onHide, initialTipoEquipamento, onSaveTipoEquipamento }) => {
  const [tipoEquipamento, setTipoEquipamento] = useState(new TipoEquipamento());
  const [novoRegistro, setNovoRegistro] = useState(true);
  const {
    tiposEquipamento,
    listarTiposEquipamento,
    adicionarTipoEquipamento,
    atualizarTipoEquipamento,
    excluirTipoEquipamento,
    handleShowTipoEquipamentoSearch,
  } = useTipoEquipamento();
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();

  const handleNovo = () => {
    setTipoEquipamento(new TipoEquipamento());
    setNovoRegistro(true);
  };

  useEffect(() => {
    if (!show) return;
    listarTiposEquipamento();
    if (initialTipoEquipamento?.id) {
      setTipoEquipamento({ ...new TipoEquipamento(), ...initialTipoEquipamento });
      setNovoRegistro(false);
    } else {
      handleNovo();
    }
  }, [show, initialTipoEquipamento]);

  const handleSelecionarTipo = async () => {
    const selecionado = await handleShowTipoEquipamentoSearch();
    if (selecionado?.id) {
      setTipoEquipamento({ ...new TipoEquipamento(), ...selecionado });
      setNovoRegistro(false);
    }
  };

  const handleTipoExit = () => {
    if (!tipoEquipamento.id) return;
    const selecionado = tiposEquipamento.find(item => Number(item.id) === Number(tipoEquipamento.id));
    if (selecionado) {
      setTipoEquipamento({ ...new TipoEquipamento(), ...selecionado });
      setNovoRegistro(false);
    } else {
      showMessage('Tipo de equipamento não encontrado!', 'warning');
      handleNovo();
    }
  };

  const handleSave = async () => {
    if (!tipoEquipamento.descricao?.trim()) {
      showMessage('Informe a descrição do tipo de equipamento!', 'warning');
      return;
    }
    const salvo = tipoEquipamento.id
      ? await atualizarTipoEquipamento(tipoEquipamento)
      : await adicionarTipoEquipamento(tipoEquipamento);
    if (!salvo) return;
    onSaveTipoEquipamento?.(salvo);
    handleNovo();
  };

  const handleDelete = async () => {
    if (!tipoEquipamento.id) {
      showMessage('Selecione um tipo de equipamento para excluir!', 'warning');
      return;
    }
    const confirmar = await showYesNo('Deseja excluir o tipo de equipamento selecionado?');
    if (confirmar) {
      const excluido = await excluirTipoEquipamento(tipoEquipamento.id);
      if (excluido) handleNovo();
    }
  };

  if (!show) return null;

  return (
    <ModalContainer show={show} variant="cadastro" onHide={onHide}>
      <ModalHeader title={novoRegistro ? 'Novo Tipo de Equipamento' : 'Alterar Tipo de Equipamento'} onHide={onHide} />
      <ModalBody>
        <form>
          <div className="d-flex gap-2 flex-wrap mb-2">
            <Input
              label="Código"
              value={tipoEquipamento.id || ''}
              onChange={e => setTipoEquipamento({ ...tipoEquipamento, id: Number(e.target.value) || 0 })}
              onBlur={handleTipoExit}
              disabled={!novoRegistro}
              btnBuscar={handleSelecionarTipo}
              size={100}
            />
            <Input
              label="Descrição"
              value={tipoEquipamento.descricao || ''}
              onChange={e => setTipoEquipamento({ ...tipoEquipamento, descricao: e.target.value })}
              size={330}
              autoFocus
            />
            <InputCheck
              id="tipo-equipamento-ativo"
              label="Ativo"
              checked={tipoEquipamento.ativo}
              onChange={e => setTipoEquipamento({ ...tipoEquipamento, ativo: e.target.checked })}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <ModalActions >
          <ModalActionButton type="button" className="btn btn-primary" onClick={handleSave} action="save">Salvar </ModalActionButton>
          <ModalActionButton type="button" className="btn btn-danger" onClick={handleDelete} disabled={novoRegistro} action="delete">Excluir </ModalActionButton>
          <ModalActionButton type="button" className="btn btn-secondary" onClick={handleNovo} disabled={novoRegistro} action="new">Novo </ModalActionButton>
        </ModalActions>
      </ModalFooter>
    </ModalContainer>
  );
};

export default TipoEquipamentoCad;
